class NouveauCollectionSalon extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
    this.buttons.forEach((button, index) => {
      button.addEventListener('click', () => this.select(index));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const last = this.buttons.length - 1;
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? last :
          (index + (event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1) + this.buttons.length) % this.buttons.length;
        this.buttons[next].focus();
        this.select(next);
      });
    });
  }

  select(index) {
    this.buttons.forEach((button, itemIndex) => {
      const selected = itemIndex === index;
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
      button.tabIndex = selected ? 0 : -1;
    });
    this.panels.forEach((panel, itemIndex) => {
      panel.hidden = itemIndex !== index;
    });
    this.dataset.active = String(index);
  }
}

if (!customElements.get('nouveau-collection-salon')) {
  customElements.define('nouveau-collection-salon', NouveauCollectionSalon);
}
